export const prepareHeaders = (headers: Headers) => {
  const accessToken = localStorage.getItem('access_token');

  if (accessToken) {
    headers.set('Authorization', 'Bearer ' + accessToken);
  }

  return headers;
};
